import { useEffect, useState } from 'react';
import { supabase } from '../supabase';

export type PartnerModel = 'segnalatore' | 'rivenditore';

/**
 * Modello del partner a cui appartiene il partner admin collegato.
 *
 * Serve al menu: le voci del portale non sono le stesse per i due modelli.
 * Al segnalatore "Le mie organizzazioni" mostra due errori rossi ("Sconto
 * rivenditore non ancora configurato", "Il partner non e' configurato come
 * rivenditore") e un pulsante che non puo' funzionare: sembra un guasto
 * nostro, mentre e' semplicemente una pagina che non lo riguarda.
 *
 * Il valore cambia solo quando lo cambiamo noi da superadmin, quindi una
 * cache di modulo evita di ripetere la query a ogni render del Layout.
 */
const cache = new Map<string, PartnerModel>();

export function usePartnerModel(partnerId: string | null): PartnerModel | null {
  const [model, setModel] = useState<PartnerModel | null>(
    partnerId ? cache.get(partnerId) ?? null : null,
  );

  useEffect(() => {
    if (!partnerId) {
      setModel(null);
      return;
    }
    const cached = cache.get(partnerId);
    if (cached) {
      setModel(cached);
      return;
    }
    let annullato = false;
    void (async () => {
      const { data } = await supabase
        .from('superadmin_seller_partner')
        .select('partner_model')
        .eq('id', partnerId)
        .single();
      const valore = data?.partner_model as PartnerModel | undefined;
      if (!valore || annullato) return;
      cache.set(partnerId, valore);
      setModel(valore);
    })();
    return () => {
      annullato = true;
    };
  }, [partnerId]);

  return model;
}
